import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../api';
import LocationAddModal from './modals/Location/locationAddModal';
import Pagination from '../Tools/Pagination';


const LocationTab = () => {
  const [locations, setLocations] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ location_name: '' });
  const [isEditMode, setIsEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentLocationId, setCurrentLocationId] = useState(null);

  const showAlert = (message, isSuccess = true) => {
    alert(`${isSuccess ? 'Success:' : 'Error:'} ${message}`);
  };

  const fetchLocations = async () => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.get('/locations');
      setLocations(response.data || []);
    } catch (error) {
      console.error('Error fetching locations:', error);
      showAlert('Failed to fetch locations', false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLocations();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const openAddModal = () => {
    setIsEditMode(false);
    setFormData({ location_name: '' });
    setShowModal(true);
  };

  const handleEdit = (location) => {
    setIsEditMode(true);
    setCurrentLocationId(location.id);
    setFormData({ location_name: location.location_name });
    setShowModal(true);
  };

  const handleSave = async () => {
    try {
      setIsLoading(true);
      if (isEditMode) {
        await axiosInstance.put(`/locations/${currentLocationId}`, formData);
        showAlert('Location updated successfully!');
      } else {
        await axiosInstance.post('/locations', formData);
        showAlert('Location added successfully!');
      }
      setShowModal(false);
      fetchLocations();
    } catch (error) {
      console.error('Save failed:', error);
      showAlert(error.response?.data?.message || 'Failed to save location', false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this location?')) {
      try {
        setIsLoading(true);
        await axiosInstance.delete(`/locations/${id}`);
        showAlert('Location deleted successfully!');
        fetchLocations();
      } catch (error) {
        console.error('Delete failed:', error);
        showAlert('Failed to delete location', false);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div className="tab-pane active" id="bs-location" role="tabpanel">
      {/* Header & Add Button */}
      <div className="filter-search mt-3">
        <h6 className="px-2 mb-0">Filter</h6>
        <div className="filter-panel">
          <form>
            <div className="form-group col-lg-6 col-12 p-2">
              <input type="text" className="form-control" placeholder="Search" />
            </div>
            </form>
        <button
          className="btn m-2 d-flex align-items-center justify-content-center btn-outline-primary"
          onClick={openAddModal}
        >
          <i className="ti ti-circle-plus fs-4 me-2"></i>
          Add Location
        </button>
      </div>
      </div>

      {/* Table */}
      {isLoading ? (
        <div className="text-center py-4">Loading locations...</div>
      ) : (
        <div className="py-3 px-0">
          <div className="table-responsive rounded-2 ros-table">
            <table className="table text-nowrap customize-table mb-0 align-middle">
              <thead className="text-dark fs-4">
                <tr>
                  <th><h6 className="fw-semibold mb-0">ID</h6></th>
                  <th><h6 className="fw-semibold mb-0">Location Name</h6></th>
                  <th><h6 className="fw-semibold mb-0">Actions</h6></th>
                </tr>
              </thead>
              <tbody>
                {locations.length > 0 ? (
                  locations.map((loc) => (
                    <tr key={loc.id}>
                      <td>{loc.id.toString().padStart(2, '0')}</td>
                      <td>{loc.location_name}</td>
                      <td>
                        <button
                          className="h4 me-3 border-0 bg-transparent"
                          onClick={() => handleEdit(loc)}
                        >
                          <i className="ti ti-edit text-warning"></i>
                        </button>
                        <button
                          className="h4 border-0 bg-transparent"
                          onClick={() => handleDelete(loc.id)}
                        >
                          <i className="ti ti-trash text-danger"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center py-4">No Locations Found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
      
      <Pagination/>
      
      {/* Modal */}
      <LocationAddModal
        show={showModal}
        onClose={() => setShowModal(false)}
        formData={formData}
        onChange={handleInputChange}
        onSave={handleSave}
        isEditMode={isEditMode}
        isLoading={isLoading}
      />
    </div>
  );
};

export default LocationTab;
